export default "__VITE_ASSET__DFQ9A5S8__"